import React from 'react'
import { useNavigate } from 'react-router-dom'
import CloseRoleDrawer from '../../../components/UIComponents/CloseRolePopup'
import ApprovedModelIcon from '../../../components/icons/TPORequestsIcons/PopupIcon/ApprovedModelIcon'

function ShortList({ showApprovalDrawer, setShowApprovalDrawer, urgentCount }) {
  const navigate = useNavigate()

  const handleYesClick = () => {
    setShowApprovalDrawer(false)
    // navigate('/tpoRequests')
    navigate({
      pathname: '/tpoRequests',
      search: '?tab=urgent',
    })
    localStorage.setItem('hasShownPopup', 'urgentRequests')
  }

  return (
    <div>
      <CloseRoleDrawer
        description={<>{urgentCount}students need your approvals now!</>}
        Icon={ApprovedModelIcon}
        showDrawer={showApprovalDrawer}
        setShowDrawer={setShowApprovalDrawer}
        onApprove={handleYesClick}
        onCloseClick={()=>setShowApprovalDrawer(false)}
        closeText={'Back'}
        YesText={'Let’s Go!'}
        closeButtonHeight={'38px'}
        closeButtonWidth={'80px'}
        yesButtonHeight={'38px'}
        yesButtonWidth={'105px'}
      />
    </div>
  )
}

export default ShortList
